module.exports = __webpack_public_path__ + "img/left_foot_on.80b274fa.png";